<template>
  <div class="w-full">
    <vx-card :title="titleCard" class="mb-base">
      <div class="flex">

        <div class="vx-col w-full md:w-1/2">

          <vs-input v-model="id_subproject" v-if="!propModeCreate" disabled label="ID Subproyecto" class="w-1/2 mb-5"/>

          <!-- Proyecto -->
          <div>
            <label class="text-sm ">Proyecto</label>
            <v-select v-model="id_project" name="id_project" label="id" class="w-1/2 mb-5"
              :options="projectList" :reduce="item => item.id" :filter="fuseSearch">
              <template #selected-option="{ id, descripcion }">
                {{ id }} - {{ descripcion }}
              </template>
              <template #option="{ id, descripcion }">
                {{ id }} - {{ descripcion }}
              </template>
            </v-select>
            <vs-input v-model="description" label="Descripcion" class="w-1/2 mb-5"/>
          </div>

        </div>
        <div class="vx-col w-full md:w-1/2">
          <div>
            <label class="text-sm ">Activo</label>
            <v-select v-model="is_active" name="is_active" label="is_active" class="w-1/2 mb-5"
              :options="isActiveList" :reduce="item => item.is_active"
              :filter="fuseSearch">
              <template #selected-option="{ is_active, descripcion }">
                {{ is_active }} - {{ descripcion }}
              </template>
              <template #option="{ is_active, descripcion }">
                {{ is_active }} - {{ descripcion }}
              </template>
            </v-select>
          </div>
          <div>
            <label class="text-sm ">Unidad de negocio</label>
            <v-select v-model="id_business_unit" name="id_business_unit" label="id_business_unit" class="w-1/2 mb-5"
              :options="businessUnitList" :reduce="item => item.id_business_unit"
              :filter="fuseSearch">
              <template #selected-option="{ id_business_unit, name }">
                {{ id_business_unit }} - {{ name }}
              </template>
              <template #option="{ id_business_unit, name }">
                {{ id_business_unit }} - {{ name }}
              </template>
            </v-select>
          </div>
        </div>
      </div>
    </vx-card>
    <div class="vx-col w-full flex" id="account-manage-buttons">
      <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" @click="actionSaveData">Guardar</vs-button>
      <vs-button type="border" color="danger" icon-pack="feather" @click="this.$props.closeSidebar">Cancelar</vs-button>
    </div>
  </div>
</template>

<script>
import ListasModule from '@/store/listas-module/moduleDataList.js'
import SubproyectosModule from '@/store/subproyectos-module/moduleDataList.js'
import Fuse from 'fuse.js'
import VxCard from '../../../components/vx-card/VxCard.vue'
import { searchCompany } from '../../../config/companies.js'
export default {
  components: { VxCard },
  data () {
    return {
      titleCard: '',
      id_subproject: null,
      id_project: null,
      description: null,
      is_active: null,
      id_business_unit: null,
      isActiveList: [
        { is_active: "Y", descripcion: 'Activo' },
        { is_active: "N", descripcion: 'Inactivo' },
      ],
      company: null,
      company_id: null,
    }
  },
  props: {
    propModeCreate: {
      type: Boolean,
      default: true
    },
    propData: {
      type: Object,
      default: () => {}
    },
    closeSidebar: {
      type: Function,
      default: () => {}
    }
  },
  computed: {
    projectList() {
      return this.$store.state.ListasModule.proyecto
    },
    businessUnitList() {
      return this.$store.state.ListasModule.business_unit
    },
  },
  created () {
    if (!ListasModule.isRegistered) {
      this.$store.registerModule('ListasModule', ListasModule)
      ListasModule.isRegistered = true
    }

    if (!SubproyectosModule.isRegistered) {
      this.$store.registerModule('SubproyectosModule', SubproyectosModule)
      SubproyectosModule.isRegistered = true
    }

    this.company = searchCompany(this.$route.params.nameCompany)
    this.company_id = this.company.idCompany

    if (this.$props.propModeCreate === true) {
      this.titleCard = 'Crear subproyecto'
    } else {
      console.log("propData: " + JSON.stringify(this.$props.propData))
      this.titleCard = 'Editar subproyecto'
      this.id_subproject = this.$props.propData.id_subproject
      this.id_project = this.$props.propData.id_project
      this.description = this.$props.propData.description
      this.is_active = this.$props.propData.is_active
      this.id_business_unit = this.$props.propData.id_business_unit
    }

    this.initListOfValues()
  },
  methods: {
    actionSaveData () {
      console.log('Guardando datos')
      const data = {
        id_subproject: this.id_subproject,
        description: this.description,
        id_project: this.id_project,
        is_active: this.is_active,
        id_business_unit: this.id_business_unit,
      }
      console.log("data to send: ", data)

      this.$store
        .dispatch('SubproyectosModule/insertOrReplaceSubproyecto', data)
        .then((response) => {
          this.$vs.dialog({
            color: 'success',
            title: 'Exito',
            text: 'Se guardó el subproyecto correctamente.',
            acceptText: 'Aceptar',
            accept: this.$props.closeSidebar.bind(this)
          })
        })
        .catch((error) => {
          this.$vs.dialog({
            color: 'danger',
            title: 'Error',
            text:
              'Error. ' + error,
            acceptText: 'Aceptar',
            accept: this.$props.closeSidebar.bind(this)
          })
          console.log(error)
        })
    },
    fuseSearch(options, search) {
      if (!search) return options;

      const fuse = new Fuse(options, {
        keys: ['id', 'descripcion'],
        threshold: 0.3,
        shouldSort: true,
      });

      const results = fuse.search(search).map(result => result.item);

      return results;
    },
    initListOfValues() {
      if (!ListasModule.isRegistered) {
        this.$store.registerModule('ListasModule', ListasModule)
        ListasModule.isRegistered = true
      }

      this.$vs.loading()
      this.$store.dispatch('ListasModule/getBusinessUnit')
        .then(() => {
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })

      this.$vs.loading()
      this.$store.dispatch('ListasModule/getAllProyecto', { ...this.company, idUser: this.$store.state.auth.userDetails().id })
        .then(() => {
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
  }
}
</script>

<style>

</style>
